export const loginParser = ({ token, organisation, roles, licences, user }) => {
  return {
    userId: user.userId,
    firstName: user.firstName,
    name: user.name,
    newsCentreSettingsSaved: user.newsCentreSettingsSaved,
    remember: true,
    token,
    licences,
    roles,
    organisation,
    organisationId: organisation.id,
  };
};
